module.exports = __webpack_public_path__ + "static/img/icon_img4.b5284fb2.png";